import {HttpClient} from "../../service/httpClient/HttpClient";

export class TagService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getTagList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                'tags',
                {page, size}
            ).then(resolve).catch(reject)
        })
    }


    addNewTag(name) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `tags`,
                {
                    name
                }
            ).then(resolve).catch(reject)
        })
    }

    updateTag(id, name) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `tags/${id}`,
                {
                    name
                }
            ).then(resolve).catch(reject)
        })
    }

    getTagDetail(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `tags/${id}`
            ).then(resolve).catch(reject)
        })
    }

    getTagOffers(limit, name) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `tags/offers`,
                {
                    name, limit,
                    page: 0,
                    size: 5
                }
            ).then(resolve).catch(reject)
        })
    }
}